module.exports = __webpack_public_path__ + "static/media/banjer-hideout.33613dd3.glb";